import { useNavigate, useLocation } from "react-router-dom";
import { useState, useRef } from "react";
import { toast } from "react-toastify";
import { useRegisterStore } from "../../store/useRegisterStore";
import { useAuthStore } from "../../store/useAuthStore";

import MainLayoutDetail from "../../components/layout/MainLayoutDetail";
import SectionBox from "../../components/layout/SectionBox";
import Button from "../../components/atoms/Button";

export default function OtpVerificationAdmin() {
  const navigate = useNavigate();
  const location = useLocation();

  const { email } = useAuthStore(); // 🔥 dari localStorage
  const { confirmOtp, resendOtp, loading } = useRegisterStore();

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

  const handleOtpChange = (value: string, index: number) => {
    if (!/^[0-9]?$/.test(value)) return;

    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async () => {
    const otpCode = otp.join("");

    if (otpCode.length !== 6) {
      toast.error("OTP must be 6 digits");
      return;
    }

    try {
      await confirmOtp({
        email: email!,
        otp: otpCode,
      });


      const currentLang = location.pathname.startsWith("/id") ? "id" : "en";
      navigate(`/${currentLang}/login`);
    } catch {
    }
  };

  const handleResend = async () => {
    try {
      await resendOtp(email!);
    } catch {
    }
  };



  return (
    <MainLayoutDetail>
      <div className="container-section mx-auto mt-32 px-6">

        {/* 🔥 Step Progress Added Here */}

        <SectionBox
          className="md:flex md:flex-col md:justify-center md:min-h-[70vh]"
          titleClassName="text-2xl md:text-3xl text-white"
          background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)"
        >

          {/* <div className="mb-10 flex justify-center">
          <StepProgress steps={steps} currentStep={1} />
        </div> */}
          <div className="bg-white p-4 rounded-2xl shadow-md max-w-lg mx-auto">
            <h2 className="text-center text-2xl font-semibold text-gray-800 mb-2">
              Email OTP Verification
            </h2>
            <p className="text-center text-gray-500 mb-6">
              Please enter the 6-digit one-time password sent to{" "}
              <span className="font-medium text-primary">*****{email?.slice(-13)}</span>
            </p>

            <div className="flex justify-center gap-1 md:gap-3 mb-6 flex-wrap">
              {otp.map((num, i) => (
                <input
                  key={i}
                  maxLength={1}
                  value={num}
                  ref={(el) => {
                    inputRefs.current[i] = el;
                  }}
                  onChange={(e) => handleOtpChange(e.target.value, i)}
                  onKeyDown={(e) => handleKeyDown(e, i)}
                  className="w-10 h-10 md:w-12 md:h-12 border rounded-lg text-center text-xl md:text-2xl font-semibold focus:outline-none focus:ring-2 focus:ring-primary"
                />
              ))}
            </div>

            <p className="text-center text-gray-500 text-sm mb-4">
              Didn’t get the code?{" "}
              <button
                onClick={handleResend}
                disabled={loading}
                className={`text-primary hover:underline transition
    ${loading ? "opacity-50 cursor-not-allowed" : ""}
  `}
              >
                {loading ? "Sending..." : "Resend verification email"}
              </button>

            </p>

            <div className="flex justify-between">
              <Button onClick={() => navigate(-1)} className="px-8 !bg-gray-400 hover:bg-gray-500">
                Back
              </Button>
              <Button onClick={handleSubmit} className="px-8 bg-primary hover:bg-secondary">
                Submit
              </Button>
            </div>
          </div>
        </SectionBox>
      </div>
    </MainLayoutDetail>
  );
}
